import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import RetargetingsGrid from '../components/Grid';
import { RetargetingProvider } from '../store';

import RetargetingFormLayout from './Form';

export default function RetargetingsGridLayout() {
  return <RetargetingProvider>
    <RetargetingsGrid />
    <Router>
      <PrivateRoute path={["/path/retargeting/add", "/path/retargeting/:id"]} component={RetargetingFormLayout} />
    </Router>
  </RetargetingProvider>;
}
